var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _path22, _ellipse, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 945.001,
    height: 908.438,
    viewBox: "0 0 945.001 908.438",
    xmlnxlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(-232 -57.317)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1648-2560",
    "data-name": "Path 1648",
    d: "M943.9,244.151s-3.74,15.893,0,27.112L927.069,273.6l-14.959-7.479V256.3s7.012-14.959,5.142-32.254Z",
    transform: "translate(-257.463 56.182) rotate(9)",
    fill: "#ffb9b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_438-2561",
    "data-name": "Path 438",
    d: "M222.885,693.524a24.215,24.215,0,0,0,23.383-4.119c8.19-6.874,10.758-18.2,12.847-28.682l6.18-31.017-12.938,8.908c-9.3,6.406-18.818,13.019-25.26,22.3s-9.252,21.947-4.078,31.988",
    transform: "translate(104.5 213.612)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439-2562",
    "data-name": "Path 439",
    d: "M224.883,733.235c-1.628-11.864-3.3-23.881-2.159-35.872,1.015-10.649,4.264-21.049,10.878-29.579a49.206,49.206,0,0,1,12.625-11.44c1.262-.8,2.424,1.2,1.167,2a46.779,46.779,0,0,0-18.5,22.326c-4.029,10.246-4.675,21.416-3.982,32.3.419,6.582,1.311,13.121,2.206,19.653a1.2,1.2,0,0,1-.808,1.423,1.164,1.164,0,0,1-1.423-.808Z",
    transform: "translate(104.5 213.612)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442-2563",
    "data-name": "Path 442",
    d: "M236.6,714.2a17.825,17.825,0,0,0,15.531,8.019c7.864-.373,14.418-5.86,20.317-11.07L289.9,695.738l-11.55-.553c-8.306-.4-16.827-.771-24.738,1.793s-15.208,8.726-16.654,16.915",
    transform: "translate(104.5 213.612)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443-2564",
    "data-name": "Path 443",
    d: "M220.28,740.055c7.84-13.871,16.932-29.288,33.181-34.216a37.028,37.028,0,0,1,13.955-1.441c1.482.128,1.112,2.412-.367,2.284a34.4,34.4,0,0,0-22.272,5.892c-6.28,4.275-11.17,10.218-15.308,16.519-2.535,3.86-4.806,7.884-7.076,11.9C221.667,742.281,219.546,741.354,220.28,740.055Z",
    transform: "translate(104.5 213.612)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442-2-2565",
    "data-name": "Path 442",
    d: "M1008.357,710.039a17.825,17.825,0,0,1-17.065,3.783c-7.508-2.371-12.442-9.35-16.813-15.9l-12.934-19.357,11.308,2.417c8.132,1.738,16.465,3.555,23.458,8.056s12.472,12.323,11.778,20.61",
    transform: "translate(104.5 213.612)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443-2-2566",
    "data-name": "Path 443",
    d: "M1017.531,739.208c-4.034-15.414-8.885-32.643-23.334-41.559a37.025,37.025,0,0,0-13.124-4.96c-1.465-.255-1.691,2.048-.229,2.3a34.4,34.4,0,0,1,20.026,11.389c4.979,5.738,8.187,12.733,10.578,19.883,1.464,4.38,2.631,8.851,3.8,13.316C1015.62,741.006,1017.908,740.652,1017.531,739.208Z",
    transform: "translate(104.5 213.612)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1686-2567",
    "data-name": "Path 1686",
    d: "M858.659,434.808H594.335c-4.395,0-7.957-.9-7.962-2V410.389c.005-1.1,3.567-2,7.962-2H858.659c4.395,0,7.956.9,7.962,2v22.417c-.005,1.1-3.567,2-7.962,2Z",
    transform: "translate(104.5 213.612)",
    fill: "#f1f1f1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1689-2568",
    "data-name": "Path 1689",
    d: "M759.012,321.315l-.292-.216-.007-.005a3.576,3.576,0,0,0-5,.739l-59.5,80.106h-6.546V400.4a1.431,1.431,0,0,0-1.431-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.26V400.4a1.431,1.431,0,0,0-1.43-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.253V400.4a1.431,1.431,0,0,0-1.43-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.26V400.4a1.431,1.431,0,0,0-1.43-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.253V400.4a1.431,1.431,0,0,0-1.43-1.431H646.24a1.43,1.43,0,0,0-1.43,1.431v1.538h-2.26V400.4a1.431,1.431,0,0,0-1.43-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.26V400.4a1.431,1.431,0,0,0-1.43-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538H624.5V400.4a1.431,1.431,0,0,0-1.43-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.26V400.4a1.431,1.431,0,0,0-1.43-1.431H610.14a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.253V400.4a1.431,1.431,0,0,0-1.43-1.431h-3.905a1.431,1.431,0,0,0-1.431,1.43v1.538h-2.832a3.576,3.576,0,0,0-3.576,3.576v3.412a3.576,3.576,0,0,0,3.576,3.576H693.62a5.329,5.329,0,0,0,5.218-4.247l.037.027,60.871-81.957.006-.007a3.577,3.577,0,0,0-.739-5Z",
    transform: "translate(104.5 213.612)",
    fill: "#090814"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1690-2569",
    "data-name": "Path 1690",
    d: "M255.5,550.825l20.476,10.186,24.316-45-21.069-11.549Z",
    transform: "translate(230 371.508)",
    fill: "#ffb7b7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1692-2570",
    "data-name": "Path 1692",
    d: "M394.317,567.652H414l4.611-52.077h-24.3Z",
    transform: "translate(232 372)",
    fill: "#ffb7b7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1694-2571",
    "data-name": "Path 1694",
    d: "M458.663,301.261s-9.041-6.927-9.041,9.993l-1.428,55.913,15.941,52.82,9.279-17.131-3.807-37.117Z",
    transform: "translate(104.5 213.612)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1695-2572",
    "data-name": "Path 1695",
    d: "M555.377,454.192s10.484,51.058-2.8,92.96l-7.339,161.107-26.909-2.1L508.9,586.642l-9.086-59.41L480.94,581.4,418.733,696.027l-28.657-22.366s31.756-86.649,55.217-104.842L457.06,434.808Z",
    transform: "translate(104.5 213.612)",
    fill: "#090814"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 30.683,
    cy: 30.683,
    r: 30.683,
    transform: "translate(586.34 428.134) rotate(-61.337)",
    fill: "#ffb7b7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1696-2573",
    "data-name": "Path 1696",
    d: "M521.309,208.822c3.678.479,6.453-3.285,7.739-6.763s2.267-7.529,5.465-9.408c4.369-2.567,9.959.52,14.955-.327,5.642-.957,9.311-6.936,9.6-12.651s-1.987-11.212-4.219-16.482l-.779,6.549a12.987,12.987,0,0,0-5.675-11.352l1,9.609a10.2,10.2,0,0,0-11.733-8.439l.158,5.726c-6.517-.775-13.09-1.551-19.626-.961s-13.118,2.658-18.071,6.963c-7.41,6.439-10.116,17.041-9.208,26.815s4.943,18.957,9.149,27.827c1.058,2.232,2.521,4.75,4.975,5.034,2.2.255,4.222-1.587,4.907-3.7a13.4,13.4,0,0,0-.06-6.585c-.62-3.295-1.4-6.662-.819-9.963s2.958-6.564,6.286-6.968,6.733,3.4,5.133,6.345Z",
    transform: "translate(104.5 213.612)",
    fill: "#090814"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1697-2574",
    "data-name": "Path 1697",
    d: "M429.776,309.458,327.357,302.85l7.709-31.937,93.608,20.925Z",
    transform: "translate(232 372)",
    fill: "#d6d6e3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1698-2575",
    "data-name": "Path 1698",
    d: "M494.114,244.158l6.424-8.919s7.18,2.44,26.41,12.012l1.359,8.356,33.379,205.3-60.671-2.617-16.522-.352-5.407-12.12-6.667,11.863-16.134-.343-16.417-9.517,16.179-49.489,5.234-45.206-8.09-42.589s-10.179-39.108,29.027-60.2Z",
    transform: "translate(104.5 213.612)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1699-2576",
    "data-name": "Path 1699",
    d: "M630.863,399.573a10.486,10.486,0,0,1-13.041-9.406l-36-9.641,14.48-12.857L628.268,378.8a10.543,10.543,0,0,1,2.595,20.777Z",
    transform: "translate(104.5 213.612)",
    fill: "#ffb7b7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1700-2577",
    "data-name": "Path 1700",
    d: "M614.741,394.13a6.142,6.142,0,0,1-4.987.4l-59.213-22.474a63.227,63.227,0,0,1-34.032-28.684l-24.693-44.049A19.765,19.765,0,1,1,521.307,273l42.74,67.742,53.787,31.534a6.155,6.155,0,0,1,2.618,6.546l-2.675,11.334a6.143,6.143,0,0,1-1.866,3.15,6.078,6.078,0,0,1-1.169.828Z",
    transform: "translate(104.5 213.612)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1701-2578",
    "data-name": "Path 1701",
    d: "M1071.5,741.388h-943a1,1,0,0,1,0-2h943a1,1,0,0,1,0,2Z",
    transform: "translate(104.5 213.612)",
    fill: "#cbcbcb"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1718-2579",
    "data-name": "Path 1718",
    d: "M1077.069,514.354H634.892V239.069h442.178ZM645.18,504.066h421.6V249.358H645.18Z",
    transform: "translate(99.932 -69.755)",
    fill: "#e5e5e5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 431.889,
    height: 264.996,
    transform: "translate(739.967 174.458)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1719-2580",
    "data-name": "Path 1719",
    d: "M1070.872,310.322V294.052h-59.913V243.16H994.688v50.891H888.025V243.16H871.754v50.891H707.239V243.16H690.968v50.891H638.983v16.271h51.985V373.6H638.983v16.271h51.985v67.795H638.983v16.271H778.649v34.223h16.27V473.934h76.834v34.223h16.271V473.934h182.847V457.663H888.025V389.868h182.847V373.6h-59.913V310.322Zm-199.118,0v19.886H707.239V310.322ZM707.239,346.48H871.754V373.6H707.239Zm0,111.183V389.868h71.411v67.795Zm164.515,0H794.92V389.868h76.834ZM994.688,373.6H888.025V310.322H994.688Z",
    transform: "translate(100.984 -68.703)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1720-2581",
    "data-name": "Path 1720",
    d: "M924.941,228.019c0,43.089-78.019,139.077-78.019,139.077S768.9,271.107,768.9,228.019a78.019,78.019,0,0,1,156.038,0Z",
    transform: "translate(134.428 -92.683)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721-2582",
    "data-name": "Path 1721",
    d: "M873.918,216.651a35.666,35.666,0,1,1-35.666-35.666A35.666,35.666,0,0,1,873.918,216.651Z",
    transform: "translate(143.098 -84.707)",
    fill: "#fff",
    style: {
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 21.031,
    cy: 21.031,
    rx: 21.031,
    ry: 21.031,
    transform: "translate(960.316 288.66)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1400-2583",
    "data-name": "Path 1400",
    d: "M308.718,792.282,331.3,803.836s35.341,8.425,12.331,15.426-33.368,2.025-33.368,2.025-30.1,1.565-29.615-6.833,6.276-20.207,6.276-20.207S307.069,799.511,308.718,792.282Z",
    transform: "translate(337.588 142.754)",
    fill: "#090814"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1745-2584",
    "data-name": "Path 1745",
    d: "M310.456,793.309,331.3,803.836s35.341,8.425,12.331,15.426-33.368,2.025-33.368,2.025-30.1,1.565-29.615-6.833,6.276-20.207,6.276-20.207S308.806,800.538,310.456,793.309Z",
    transform: "translate(430.732 76.229) rotate(16)",
    fill: "#090814"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1746-2585",
    "data-name": "Path 1746",
    d: "M882.754,434.808H595.039c-4.784,0-8.661-.9-8.666-2V410.389c.005-1.1,3.882-2,8.666-2H882.754c4.784,0,8.661.9,8.666,2v22.417c-.005,1.1-3.882,2-8.666,2Z",
    transform: "translate(1252.598 58.976) rotate(90)",
    fill: "#f1f1f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTack);
export default __webpack_public_path__ + "static/media/tack.302beb8f3b179edf6af16cbc5a3d59eb.svg";
export { ForwardRef as ReactComponent };